import * as React from "react";
import { useContext } from "react";
import { Form, TextArea } from "semantic-ui-react";
import { ConditionalFileProps, QAPropsBase } from "../State";
import { inputChangeFn, store, validatorFn } from "../store";

// tslint:disable-next-line: interface-name
interface Props {
    propsBase: QAPropsBase;
    index: number;
    validator?: validatorFn;
    onChange?: inputChangeFn;
    disallowMultiple?: boolean;
    acceptedFileExtensions?: string;
}

const FileAnswer: React.FunctionComponent<Props> = (props: Props) => {
  const globalState = useContext(store);
  const { dispatch } = globalState;

  return (
      <div>
          <Form.Input required id="fileUpload" type="file" multiple={!props.disallowMultiple}
              name="Dispute.Files" accept={props.acceptedFileExtensions ? props.acceptedFileExtensions : "*.*"}
              onChange={(e, d) => props.onChange ? props.onChange(e, d) : dispatch({
                  type: "handle answer update",
                  index: props.index,
                  value: e.target.files
              })} />
        </div>
    );
  };

export default FileAnswer;
